export const home = {
  "Você tem assinaturas pendentes.": "Tienes firmas pendientes.",
  "Para regulariza-las baixe o aplicativo da MarQ. e faça as solicitações.": "Para regularizarlas, descarga la aplicación de MarQ. y haz las solicitudes.",
  "Baixe agora.": "Descarga ahora.",
  "Você tem uma admissão online em aberto.": "Tienes una admisión online abierta.",
  "Para regulariza-la baixe o aplicativo da MarQ. e faça as solicitações.": "Para regularizarla, descarga la aplicación de MarQ. y haz las solicitudes.",
  "Que tal relembrar ": "Qué tal recordar ",
  "os seus momentos": "tus momentos",
  "com a gente?": "con nosotros?",
  "Relembrar o meu ano": "Recordar mi año",
  "Retro": "Retro",
  "Você está em regime de sobreaviso": "Estás en régimen de sobreaviso",
  "Hora de início do regime:": "Hora de inicio del régimen:",
  "Hora de término do regime:": "Hora de finalización del régimen:",
  "Hora:": "Hora:",
  "Último ponto registrado:": "Último punto registrado:",
  "Nenhum ponto registrado": "Ningún punto registrado",
  "Horas faltantes": "Horas faltantes",
  "Jornada Completa": "Jornada Completa",
  "Ver detalhes de hoje": "Ver detalles de hoy",
  "Ponto em processamento": "Fichaje en procesamiento",
  "Seu ponto das": "Tu fichaje de las",
  "já foi registrado!": "ya ha sido registrado!",
  "Atualize a página para visualizar o ponto.": "Actualiza la página para visualizar el fichaje.",
  "Atualizar página": "Actualizar página",
  "Pausa iniciada em:": "Pausa iniciada en:",
  "Você está em": "Estás en",
  "pausa": "pausa",
  "Voltar da pausa": "Volver de la pausa",
  "Saldo de horas": "Saldo de horas",
  "Saldo acumulado desde": "Saldo acumulado desde",
  "Não lido": "No leído",
  "Detalhes": "Detalles",
  "Reuniões 1:1": "Reuniones 1:1",
  "Confira suas reuniões 1:1 agendadas, após o término, não se esqueça de avaliá-las.": "Consulta tus reuniones 1:1 programadas, después del término, no olvides evaluarlas.",
  "Novo lembrete": "Nuevo recordatorio",
  "Você tem um novo lembrete, clique aqui para ver os detalhes.": "Tienes un nuevo recordatorio, haz clic aquí para ver los detalles.",
  "Tarefas pendentes": "Tareas pendientes",
  "Você tem tarefas pendentes em seu nome, clique aqui para ver os detalhes": "Tienes tareas pendientes a tu nombre, haz clic aquí para ver los detalles",
  "Últimos 10 dias": "Últimos 10 días",
  "Ver histórico": "Ver histórico",
  "Data": "Fecha",
  "Trabalhado": "Trabajado",
  "Saldo": "Saldo",
  "Status": "Estado",
  "Nenhum registro": "Ningún registro",
  "Comunicados": "Comunicados",
  "Ver todos": "Ver todos",
  "Nenhum comunicado": "Ningún comunicado",
  "Novo comunicado": "Nuevo comunicado",
  "Assinatura": "Firma",
  "Você tem uma assinatura pendente, abra para regularizar a solicitação.": "Tienes una firma pendiente, abre para regularizar la solicitud.",
  "Novo chat": "Nuevo chat",
  "Você tem uma nova mensagem no chat clique para ver a mensagem": "Tienes un nuevo mensaje en el chat, haz clic para ver el mensaje",
  "Admissão online": "Admisión online",
  "Preencha aqui as informações necessárias de admissão": "Rellena aquí la información necesaria de admisión",
  "Chegou um feedback": "Llegó un feedback",
  "Você tem um novo Feedback, veja o que estão sentindo do seu trabalho": "Tienes un nuevo Feedback, mira lo que están sintiendo de tu trabajo",
  "Envio de documento": "Envío de documento",
  "Você tem um ou mais documentos pendentes para serem enviados": "Tienes uno o más documentos pendientes para ser enviados",
  "Espelho ponto": "Hoja de control horario",
  "Você tem um ou mais espelhos de ponto para serem assinados": "Tienes una o más hojas de control horario para ser firmadas",
  "Ocorrências": "Incidencias",
  "Solicite os ajustes necessários para resolver as suas ocorrências": "Solicita los ajustes necesarios para resolver tus incidencias",
  "GET_MY_TEAMS": "GET_MY_TEAMS",
  "realodPage": "realodPage",
  "Férias": "Vacaciones",
  "Afastamento": "Ausencia",
  "Solicitado": "Solicitado",
  "Aprovado": "Aprobado",
  "Recusado": "Rechazado",
  "Concluído": "Concluido",
  "Ocorrência": "Incidencia",
  "Falta": "Falta",
  "Dia atual": "Día actual",
  "Fechar": "Cerrar",
  "Admissão": "Admisión",
  "Este é o horário oficial central e pode estar diferente do horário do seu computador.": "Este es el horario oficial central y puede ser diferente del horario de tu ordenador.",
  "dica de ferramenta": "consejo de herramienta",
  "Em caso de dúvidas sobre seu saldo, entre em contato com seu RH ou Gestor.": "En caso de dudas sobre tu saldo, ponte en contacto con tu RRHH o Gestor.",
  "Em caso de dúvidas sobre seu saldo, entre em contato com seu RH ou Gestor. Última atualização do histórico de dias foi feita no dia": "En caso de dudas sobre tu saldo, ponte en contacto con tu RRHH o Gestor. La última actualización del histórico de días fue hecha el día",
  "Última atualização dos comunicados foi feita no dia": "La última actualización de los comunicados fue hecha el día"
};


// WEBPACK FOOTER //
// ./src/resources/es/home.js